<template>
  <div
    class="hvf-zoom-canvas-wrapper interactive-canvas-wrapper"
    id="hvf-zoom-wrapper"
    ref="wrapper"
    tabindex="0"
    @wheel.prevent="wheel"
    @keydown.up.prevent="$emit('scrollUp')"
    @keydown.down.prevent="$emit('scrollDown')"
    @mousedown.self.left.prevent="handleMousedown"
    @mouseup.self.left.prevent="handleMouseup"
    @mousemove.self.prevent="handleMousemove"
    @mouseout.self.prevent="handleMouseout"
    @click="handleClick"
    v-hammer:panstart="handlePanstart"
    v-hammer:pan="handlePanmove"
    v-hammer:panend="handlePanend"
    v-hammer:tap="handleTap">
    <image-not-found v-if="imgNotFound" />
    <canvas-image
      :canvasSize="controlSize"
      :imgSize="imgSize"
      :transform="controlTransform"
      :img="thumb"/>
    <canvas-annotation :canvasSize="controlSize" :imgSize="controlSize" :annotation="viewFinder" />
    <v-progress-circular v-if="imgIsLoading" class="escalon-absolute-center" indeterminate />
  </div>
</template>

<script>
import HVFViewFinder from "../../../canvas/annotations/hvfViewFinder";
import canvasImage from "../../../canvas/components/CanvasImage";
import canvasAnnotation from "../../../canvas/components/CanvasAnnotation";
import touchMouseEvents from "../../mixins/TouchMouseEvents";
import imageNotFound from "../../misc/ImageNotFound";
import { mapWatchers } from "../../../helpers/utils";
import { defaultTransform, getZoom, setOffsets, setTransformSizes } from "../../../canvas/geometry";
export default {
  name: "hvfZoomControl",
  mixins: [touchMouseEvents],
  components: { canvasImage, canvasAnnotation, imageNotFound },
  props: ["controlSize", "image", "canvasSize", "scroll"],
  data() {
    return {
      viewFinder: new HVFViewFinder(),
      controlTransform: defaultTransform(),
      imageTransform: defaultTransform()
    };
  },
  computed: {
    imgSize() {
     return this.image && this.image.imgSize
    },
    imgNotFound() {
      return !!(this.image && this.image.imgNotFound);
    },
    imgIsLoading() {
      return this.image && (this.image.imgIsLoading || this.image.imgIsQueued);
    },
    thumb() {
      return this.image && this.image.thumbHtmlObject;
    }
  },
  methods: {
    updateViewFinder() {
      this.controlTransform.zoom = getZoom(this.controlSize, this.imgSize);
      setTransformSizes(this.controlTransform, this.controlSize, this.imgSize);
      setOffsets(this.controlTransform);

      this.viewFinder.updateViewFinder(
        this.controlSize,
        this.controlTransform,
        this.imgSize,
        this.canvasSize,
        this.scroll
      );
    },
    setScroll(y) {
      let h = (this.controlSize.h - this.viewFinder.height);
      let scroll = (y - this.viewFinder.height / 2) / h;
      this.$emit("scrollTo", scroll);
    },
    wheel(e) {
      let event = e.deltaY < 0 ? "scrollUp" : "scrollDown";
      this.$emit(event);
    },
    handleInteractionStart(e){
      this.$refs.wrapper.focus();
      this.setScroll(e.offsetY);
    },
    handleInteractionMove(e){
      if (this.isMousedown) this.setScroll(e.offsetY);
    }
  },
  watch: {
    ...mapWatchers(
      ["controlSize", "imgSize", "canvasSize", "scroll"],
      function() {
        this.updateViewFinder();
      },
      true
    ),
    ...mapWatchers(["image"], function() {
      this.updateViewFinder();
    })
  },
  mounted() {
    this.updateViewFinder();
  }
};
</script>